// extracted by mini-css-extract-plugin
export default {"box":"FilterCity_box__xewwp","input":"FilterCity_input__T4X9f","boxLoading":"FilterCity_boxLoading__VUk12"};